module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_chocolatey_dark_chocolate-7fb75875.png";